<style>
a {
  text-decoration: none;
}
</style>
<template>
  <v-app>
    <v-app-bar app style="background: #06377a" dark>
      <router-link to="/">
        <div class="d-flex align-center">
          <v-img
            alt="Vuetify Name"
            class="shrink mt-1 hidden-sm-and-down"
            contain
            min-width="100"
            src="./assets/emaster.png"
            width="140"
          />
        </div>
      </router-link>

      <router-link to="/">
        <v-btn text style="margin-left: 20px">
          <span class="mr-2">Home</span>
        </v-btn>
      </router-link>

      <div v-if="role == 'APP1' || role == 'APP2'">
        <router-link to="/listApprove">
          <v-btn text retain-focus-on-click="true">
            <span class="mr-2">Approval List</span>
          </v-btn>
        </router-link>
      </div>

      <div v-if="role == 'PROC'">
        <router-link to="/listProcurement">
          <v-btn text retain-focus-on-click="true">
            <span class="mr-2">Procurement List</span>
          </v-btn>
        </router-link>
      </div>

      <div v-if="role == 'ADM'">
        <template>
          <v-menu top offset-y>
            <template v-slot:activator="{ on }">
              <v-btn text dark v-on="on"> Master Data 1</v-btn>
            </template>

            <v-list>
              <v-list-item-group>
                <v-list-item to="/company">
                  <v-list-item-title style="width: 200px">
                    Company
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/plant">
                  <v-list-item-title style="width: 200px">
                    Plant
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/industry-sector">
                  <v-list-item-title style="width: 200px">
                    Industry Sector
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/materialType">
                  <v-list-item-title style="width: 200px">
                    Material Type
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/base-unit">
                  <v-list-item-title style="width: 200px">
                    Base Unit
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/uom">
                  <v-list-item-title style="width: 200px">
                    Order Unit
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/departement">
                  <v-list-item-title style="width: 200px">
                    Division
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/labOffice">
                  <v-list-item-title style="width: 200px">
                    Lab Office
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/basic-material">
                  <v-list-item-title style="width: 200px">
                    Basic Material
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/purchasing-group">
                  <v-list-item-title style="width: 200px">
                    Purchasing Group
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/purchasing-value">
                  <v-list-item-title style="width: 200px">
                    Purchasing Value
                  </v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </template>

        <template>
          <v-menu top offset-y>
            <template v-slot:activator="{ on }">
              <v-btn text dark v-on="on"> Master Data 2 </v-btn>
            </template>

            <v-list>
              <v-list-item-group>
                <v-list-item to="/mrp-group">
                  <v-list-item-title style="width: 200px">
                    MRP Group
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/mrp-type">
                  <v-list-item-title style="width: 200px">
                    MRP Type
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/mrp-control">
                  <v-list-item-title style="width: 200px">
                    MRP Control
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/mrp-profile">
                  <v-list-item-title style="width: 200px">
                    MRP Profile
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/lot-size-procedure">
                  <v-list-item-title style="width: 200px">
                    Lot Size Procedure
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/procurement-type">
                  <v-list-item-title style="width: 200px">
                    Procurement Type
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/special-proc">
                  <v-list-item-title style="width: 200px">
                    Special Proc
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/availibility-check">
                  <v-list-item-title style="width: 200px">
                    Availibility Check
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/valuation-category">
                  <v-list-item-title style="width: 200px">
                    Valuation Category
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/valuation-type">
                  <v-list-item-title style="width: 200px">
                    Valuation Type
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/valuationClass">
                  <v-list-item-title style="width: 200px">
                    Valuation Class
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/priceControl">
                  <v-list-item-title style="width: 200px">
                    Price Control
                  </v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </template>

        <template>
          <v-menu top offset-y>
            <template v-slot:activator="{ on }">
              <v-btn text dark v-on="on"> Name-Group-MFR</v-btn>
            </template>

            <v-list class="mt-10">
              <v-list-item-group>
                <v-list-item to="/inc">
                  <v-list-item-title style="width: 200px">
                    INC Item
                  </v-list-item-title>
                </v-list-item>
                <v-list-item to="/incAttribute">
                  <v-list-item-title style="width: 200px">
                    INC Attribute
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/materialGroup">
                  <v-list-item-title style="width: 200px">
                    Material Group
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/externalGroup">
                  <v-list-item-title style="width: 200px">
                    External Group
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/manufacturer">
                  <v-list-item-title style="width: 200px">
                    Manufacturer
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/storage-location">
                  <v-list-item-title style="width: 200px">
                    Storage Location
                  </v-list-item-title>
                </v-list-item>

                <!-- <v-list-item to="/serviceInitial">
                  <v-list-item-title style="width: 200px">
                    Initial SAP
                  </v-list-item-title>
                </v-list-item> -->
              </v-list-item-group>
            </v-list>
          </v-menu>
        </template>

        <!-- <template>
          <v-menu top offset-y>
            <template v-slot:activator="{ on }">
              <v-btn text dark v-on="on"> User </v-btn>
            </template>

            <v-list>
              <v-list-item-group>
                <v-list-item to="/role" style="display: none">
                  <v-list-item-title style="width: 200px">
                    Role
                  </v-list-item-title>
                </v-list-item>

                <v-list-item to="/user">
                  <v-list-item-title style="width: 200px">
                    User
                  </v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </template> -->

        <router-link to="/user">
          <v-btn text retain-focus-on-click="true">
            <span class="mr-2">User</span>
          </v-btn>
        </router-link>

        <router-link to="/initialItem">
          <v-btn text retain-focus-on-click="true">
            <span class="mr-2">SAP Material Data</span>
          </v-btn>
        </router-link>
      </div>

      <div v-if="role == 'REQ' || role == 'CAT'">
        <router-link to="/searchRegister">
          <v-btn text retain-focus-on-click="true">
            <span class="mr-2">Item Search</span>
          </v-btn>
        </router-link>
      </div>

      <div v-if="role == 'REQ'">
        <v-menu top offset-y>
          <template v-slot:activator="{ on }">
            <v-btn text dark v-on="on">Registration</v-btn>
          </template>

          <v-list class="mt-10">
            <v-list-item-group>
              <v-list-item to="/listRegister">
                <v-list-item-title style="width: 200px">
                  Registration List
                </v-list-item-title>
              </v-list-item>

              <v-list-item to="/listRegisterOutstanding">
                <v-list-item-title style="width: 200px">
                  Registration Outstanding
                </v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </div>

      <div v-if="role == 'CAT'">
        <v-menu top offset-y>
          <template v-slot:activator="{ on }">
            <v-btn text dark v-on="on"> Cataloguing</v-btn>
          </template>

          <v-list class="mt-10">
            <v-list-item-group>
              <v-list-item to="/listCatalog">
                <v-list-item-title style="width: 200px">
                  Cataloguing Queue
                </v-list-item-title>
              </v-list-item>

              <v-list-item to="/listCatalogProcess">
                <v-list-item-title style="width: 200px">
                  Cataloguing List
                </v-list-item-title>
              </v-list-item>

              <v-list-item to="/listCatalogOutstanding">
                <v-list-item-title style="width: 200px">
                  Cataloguing Outstanding
                </v-list-item-title>
              </v-list-item>

              <v-list-item to="/listCatalogUploadMaterial">
                <v-list-item-title style="width: 200px">
                  Cataloguing Upload
                </v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>

        <router-link to="/initialItem">
          <v-btn text retain-focus-on-click="true">
            <span class="mr-2">SAP Material Data</span>
          </v-btn>
        </router-link>
      </div>

      <template
        v-if="role == 'CAT' || role == 'ADM' || role == 'APP1' || role == 'REQ'"
      >
        <v-menu top offset-y>
          <template v-slot:activator="{ on }">
            <v-btn text dark v-on="on"> Dashboard </v-btn>
          </template>

          <v-list class="mt-10">
            <v-list-item-group>
              <v-list-item to="/RequestRatio">
                <v-list-item-title style="width: 200px"
                  >Done Request Ratio</v-list-item-title
                >
              </v-list-item>

              <v-list-item to="/AverageSLA">
                <v-list-item-title style="width: 200px"
                  >SLA Report</v-list-item-title
                >
              </v-list-item>

              <v-list-item to="/ApproveRatio">
                <v-list-item-title style="width: 200px"
                  >Approve Rejected Ratio</v-list-item-title
                >
              </v-list-item>

              <v-list-item to="/TopRequester">
                <v-list-item-title style="width: 200px"
                  >Top Requester</v-list-item-title
                >
              </v-list-item>

              <v-list-item to="/logFeedback">
                <v-list-item-title style="width: 200px">
                  Log Feedback
                </v-list-item-title>
              </v-list-item>

              <!--<v-list-item to='/TopApprover'>
                      <v-list-item-title style="width:200px">Top Aprovers</v-list-item-title>
                    </v-list-item>
                    <v-list-item to='/TopComplain'>
                      <v-list-item-title style="width:200px">Top Complain Category</v-list-item-title>
                    </v-list-item>-->
            </v-list-item-group>
          </v-list>
        </v-menu>
      </template>

      <v-spacer></v-spacer>

      <template>
        <div class="text-center">
          <v-menu offset-y transition="slide-y-transition">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on">
                <v-icon>mdi-account-circle</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-list>
                <v-list-item-group>
                  <v-list-item>
                    <v-list-item-title style="width: 250px">
                      <v-icon
                        style="margin-top: -3px; margin-right: 5px"
                        color="primary"
                        >mdi-account-circle</v-icon
                      >
                      {{ fullname }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    v-for="(item, index) in setting"
                    :key="index"
                    :to="item.link"
                  >
                    <v-list-item-title style="width: 250px">{{
                      item.title
                    }}</v-list-item-title>
                  </v-list-item>

                  <v-list-item v-on:click="logout()">
                    <v-list-item-title style="width: 250px"
                      >Logout</v-list-item-title
                    >
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-menu>
        </div>
      </template>
    </v-app-bar>

    <v-content>
      <div><router-view /></div>
    </v-content>

    <div align="center" style="padding: 20px; color: grey">
      Copyright&copy; 2023 | <b>E-Master PT. Cipta Kridatama</b>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "App",
  methods: {
    logout() {
      // localStorage.setItem("username", "");
      // localStorage.setItem("fullname", "");
      // window.localStorage.setItem("role", "");
      // window.localStorage.setItem("departement_id", "");
      // window.localStorage.setItem("departement_desc", "");
      // window.localStorage.setItem("company_id", "");
      // window.localStorage.setItem("company_name", "");
      localStorage.clear()

      this.$router.push("/login")
    },
    login_check() {
      var username = localStorage.getItem("username")
      var fullname = localStorage.getItem("fullname")
      var server = localStorage.getItem("server")
      var role = localStorage.getItem("role")

      if (!username || !fullname || !role || !server) {
        this.$router.push("/login")
      }
    },
  },
  mounted() {
    this.login_check()
  },
  data: () => ({
    items: [
      { title: "Master User" },
      { title: "Master Brand" },
      { title: "Master UOM" },
      { title: "Master Type" },
      { title: "Master Division" },
      { title: "Master Unit" },
      { title: "Master Role" },
      { title: "Master Color" },
    ],
    setting: [],
    username: atob(localStorage.getItem("username")),
    departement_desc: atob(localStorage.getItem("departement_desc")),
    fullname: atob(localStorage.getItem("fullname")),
    role: atob(localStorage.getItem("role")),
  }),
}
</script>
